import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';

import type { GalleryPhotoType } from '../constants/sensorGalleryType';
import { equipmentImagesListKey } from './useEquipmentImagesListQuery';

interface ISaveEquipmentImagesData {
  url: string;
  imageType: GalleryPhotoType;
  installationPointIds?: number[];
}

interface IProps {
  equipment_Id?: string;
  data: ISaveEquipmentImagesData[];
}

const updateEquipmentImagesListFn = ({ equipment_Id, data }: IProps) => {
  return apiClient.post(`${APP_API_URL_V2}fsd/equipment/${equipment_Id}/photos/batch`, {
    photos: data,
  });
};

export const useSaveEquipmentImagesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateEquipmentImagesListFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
    },
  });
};
